import * as types from './mutation-types'
import { COOKIE_NAME } from 'enums/cookie'
import Cookies from 'js-cookie'
import api from '@/utils/api'
import { parseJwt } from '@/plugins/helper'

export const state = () => ({
  accessToken: null
})

export const getters = {
  accessToken: state => state.accessToken,
  isLoggedIn: state => !!state.accessToken,
  userId: state => {
    if (!state.accessToken) return null

    return parseJwt(state.accessToken)?.sub || null
  }
}

export const mutations = {
  [types.SET_ACCESS_TOKEN](state, at) {
    if (!at) return

    Cookies.set(COOKIE_NAME.ACCESS_TOKEN, at)
    state.accessToken = at
  },
  [types.DELETE_ACCESS_TOKEN](state) {
    Cookies.remove(COOKIE_NAME.ACCESS_TOKEN)
    state.accessToken = null
    state.isLoggedIn = false
  }
}

export const actions = {
  async requestSendCodeToEmail(_, { payload, captchaKey }) {
    const settings = {
      headers: { GoogleCaptchaResponseKey: captchaKey }
    }

    await this.$axios.post(
      api.authentication.sendCodeToEmail(),
      payload,
      settings
    )
  },
  async requestConfirmEmail({ commit }, { payload, captchaKey }) {
    const settings = {
      headers: { GoogleCaptchaResponseKey: captchaKey }
    }

    const {
      data: { AccessToken }
    } = await this.$axios.post(
      api.authentication.confirmEmail(),
      payload,
      settings
    )

    commit(types.SET_ACCESS_TOKEN, AccessToken)
  },
  async requestSignInWithGoogle({ commit }, { payload }) {
    try {
      const {
        data: { AccessToken }
      } = await this.$axios.post(api.authentication.signInGoogle(), payload)

      commit(types.SET_ACCESS_TOKEN, AccessToken)
    } catch (err) {
      throw err
    }
  },
  async requestSignInWithTwitter({ commit }, { payload }) {
    try {
      const {
        data: { AccessToken }
      } = await this.$axios.post(api.authentication.signInTwitter(), payload)

      commit(types.SET_ACCESS_TOKEN, AccessToken)
    } catch (err) {
      throw err
    }
  },
  async requestTwitterAuthUrl(_, { payload }) {
    try {
      const {
        data: { OAuthUrl }
      } = await this.$axios.post(api.twitter.getOAuthUrl(), payload)

      return OAuthUrl
    } catch (err) {
      throw err
    }
  }
}
